import * as Updates from 'expo-updates';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AppState, Platform } from 'react-native';

import ModalConfirmation from '../ModalConfirmation';

export default function UpdateModal() {
  const [isVisible, setVisible] = useState(false);
  const { t } = useTranslation();
  const appState = useRef(AppState.currentState);

  const handleAppStateChange = useCallback(async (nextAppState: any) => {
    if (appState.current.match(/inactive|background/) && nextAppState === 'active') {
      const result = await Updates.checkForUpdateAsync();
      if (result.isAvailable) {
        await Updates.fetchUpdateAsync();
        setVisible(true);
      }
    }

    appState.current = nextAppState;
  }, []);

  useEffect(() => {
    if (Platform.OS === 'web' || __DEV__) return;

    let mounted = true;
    const checkForUpdatesOnMount = async () => {
      const result = await Updates.checkForUpdateAsync();
      if (result.isAvailable && mounted) {
        setVisible(true);
      }
    };
    checkForUpdatesOnMount();
    const appStateSubscription = AppState.addEventListener('change', handleAppStateChange);

    return () => {
      mounted = false;
      appStateSubscription.remove();
    };
  }, [handleAppStateChange]);

  if (Platform.OS === 'web' || __DEV__) return null;

  return (
    <ModalConfirmation
      title={t('updateModal.updateAvailable')}
      description={t('updateModal.updateAvailableMessage')}
      rightButtonText={t('updateModal.update')}
      isVisible={isVisible}
      onCloseModal={() => setVisible(false)}
      onConfirmModal={async () => await Updates.reloadAsync()}
      onCancelButton={() => setVisible(false)}
      oneOptionOnly
    />
  );
}
